
import { NavLink } from "react-router-dom";

interface MainNavigationProps {
  isEnglish: boolean;
  isSwedish: boolean;
  isArabic: boolean;
  isHebrew: boolean;
  isArticlePage?: boolean; // New prop to handle article pages
}

export const MainNavigation = ({ 
  isEnglish, 
  isSwedish, 
  isArabic, 
  isHebrew,
  isArticlePage = false
}: MainNavigationProps) => {
  // Article pages should use Finnish navigation
  const useFinishNav = !isEnglish && !isSwedish && !isArabic && !isHebrew || isArticlePage;
  
  // Base path based on language - using only short language codes
  const basePath = useFinishNav
    ? ""
    : isEnglish 
      ? "/en" 
      : isSwedish 
        ? "/sv" 
        : isArabic 
          ? "/ar"
          : "/he";

  // Navigation items with conditional paths
  const navItems = [
    {
      id: "kilpailuta",
      label: useFinishNav
        ? "Kilpailuta laina"
        : isEnglish 
          ? "Apply for loan" 
          : isSwedish 
            ? "Ansök om lån" 
            : isArabic 
              ? "التقدم للحصول على قرض"
              : "בקש הלוואה",
      path: useFinishNav 
        ? "/kilpailuta"
        : `${basePath}/apply`
    },
    {
      id: "lainat",
      label: useFinishNav
        ? "Lainatuotteet"
        : isEnglish 
          ? "Loan products" 
          : isSwedish 
            ? "Låneprodukter" 
            : isArabic 
              ? "منتجات القروض"
              : "מוצרי הלוואה",
      path: useFinishNav
        ? "/lainatuotteet"
        : `${basePath}/products`
    },
    {
      id: "articles",
      label: useFinishNav
        ? "Artikkelit & Oppaat"
        : isEnglish 
          ? "Guides" 
          : isSwedish 
            ? "Guider" 
            : isArabic 
              ? "أدلة"
              : "מדריכים",
      path: useFinishNav
        ? "/artikkelit"
        : `${basePath}/info`
    },
    {
      id: "meista",
      label: useFinishNav
        ? "Meistä"
        : isEnglish 
          ? "About" 
          : isSwedish 
            ? "Om oss" 
            : isArabic 
              ? "معلومات عنا"
              : "אודות",
      path: useFinishNav
        ? "/meista"
        : `${basePath}/info`
    },
    {
      id: "yhteystiedot",
      label: useFinishNav
        ? "Yhteystiedot"
        : isEnglish 
          ? "Contact" 
          : isSwedish 
            ? "Kontakt" 
            : isArabic 
              ? "اتصل"
              : "צור קשר",
      path: useFinishNav
        ? "/yhteystiedot"
        : `${basePath}/info`
    }
  ];

  return (
    <nav className="flex items-center space-x-1 md:space-x-4">
      {navItems.map((item) => (
        <NavLink
          key={item.id}
          to={item.path}
          end
          className={({ isActive }) =>
            `px-3 py-2 font-medium text-sm rounded-md transition-colors ${
              isActive
                ? "text-blue-700 bg-blue-100"
                : "text-blue-600 hover:text-blue-800 hover:bg-blue-50"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
};
